import React from "react";

const SkillHero: React.FC = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center px-3 w-full">
        <div className="text-center text-white text-2xl md:text-3xl pt-5 w-full max-w-4xl lg:text-4xl font-light xl:text-[3.4rem] xl:space-y-7">
          <h3 className="">Skill Development: Empowering</h3>
          <h3>India's Future Workforce</h3>
        </div>
        <p className="pt-4 xl:pt-8 text-sm xl:text-2xl text-center max-w-4xl font-light text-[#FF7E00]">
          At Dream Weavers, our journey is driven by the vision of building a
          skilled and self-reliant India. With a proven track record of
          upskilling and empowering over 20 million candidates, we are committed
          to creating meaningful opportunities for individuals and communities
          alike.
        </p>
      </div>
      <div className="flex justify-center items-center pt-[5rem] xl:pt-[5.5rem] -mb-[8rem] md:pt-10 md:-mb-[13rem] xl:-mb-[27rem]">
        <div className="max-w-lg md:max-w-2xl xl:h-[637px] xl:max-w-[90rem]">
          <iframe
            title="YouTube video player"
            src="https://www.youtube.com/embed/CpL_y9A4-Nc?si=q9r-m-BKIROiNULu"
            className="max-w-lg md:max-w-2xl h-[12rem] sm:h-[19rem] rounded-xl lg:rounded-3xl md:w-[34rem] lg:h-[28rem] sm:w-[29rem] lg:max-w-4xl xl:h-[32rem] lg:w-[90rem]"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default SkillHero;
